// Composant de partage LinkedIn (ouvre la fenêtre de share LinkedIn dans un onglet).
import { Linkedin, Twitter, Link2, Check } from"lucide-react";
import { useState } from"react";

const APP_URL = typeof window !=="undefined" ? window.location.origin :"";

function buildShareText({ kind, scoreText }) {
 const map = {
 quiz: `Je m'entraîne au Plan Comptable Général 2025 sur PCG-Apprend (832 comptes documentés + 30 quiz). ${scoreText} 🎯`,
 exercice: `Je viens de terminer un exercice guidé de comptabilité (cas pratique multi-écritures) sur PCG-Apprend. ${scoreText} 📚`,
 streak: `${scoreText} bonnes réponses d'affilée sur PCG-Apprend ! Le PCG n'a plus de secret 📖`,
 default: `Je révise le Plan Comptable Général 2025 sur PCG-Apprend — 832 comptes, 30 quiz, 3 exercices guidés.`,
 };
 return map[kind] || map.default;
}

export default function ShareButtons({ kind ="default", scoreText ="" }) {
 const [copied, setCopied] = useState(false);
 const text = buildShareText({ kind, scoreText });
 const url = APP_URL;

 const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
 url
 )}&summary=${encodeURIComponent(text)}`;

 const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
 `${text}\n\n${url}`
 )}`;

 const copyLink = async () => {
 try {
 await navigator.clipboard.writeText(`${text}\n\n${url}`);
 setCopied(true);
 setTimeout(() => setCopied(false), 2000);
 } catch (e) {
 console.warn("ShareButtons: clipboard copy failed", e);
 }
 };

 return (
 <div data-testid="share-buttons" className="flex flex-wrap gap-2">
 <a
 data-testid="share-linkedin"
 href={linkedinUrl}
 target="_blank"
 rel="noopener noreferrer"
 className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-keyto bg-white text-slate-700 hover:bg-blue-50 hover:text-[#2D6BE0] hover:border-[#2D6BE0] transition-colors text-sm font-semibold shadow-keyto-sm"
 >
 <Linkedin size={14} /> Partager sur LinkedIn
 </a>
 <a
 data-testid="share-twitter"
 href={twitterUrl}
 target="_blank"
 rel="noopener noreferrer"
 className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-keyto bg-white text-slate-700 hover:bg-slate-50 transition-colors text-sm font-semibold shadow-keyto-sm"
 >
 <Twitter size={14} /> X / Twitter
 </a>
 <button
 data-testid="share-copy"
 onClick={copyLink}
 className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-keyto bg-white text-slate-700 hover:bg-slate-50 transition-colors text-sm font-semibold shadow-keyto-sm"
 >
 {copied ? <Check size={14} /> : <Link2 size={14} />}
 {copied ?"Lien copié" :"Copier le lien"}
 </button>
 </div>
 );
}
